export const SUBPROTOCOL = '1.0.0';

export const CALL_RADIUS = 2,
  STAGED_RADIUS = 4,
  UNSUB_RADIUS = 12;
